import api from '@pray/shared/utils/api';

export const getArtistLeadCampaigns = async ({
  artistId,
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  options = {},
  search = '',
} = {}) => {
  if (!artistId) throw Error('Artist ID is required');

  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (search) params.search = search;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/lead-campaigns`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data;
};
